import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { addDays } from 'date-fns';
import { AvailableDateRangeOptions, DateRangeSelectorService } from './date-range-selector.service';
import { Observable, Subscription } from 'rxjs';
import { MatRadioChange } from '@angular/material/radio';
import { provideGalaxyDateAdapter } from '@vendasta/galaxy/datepicker';
import { CustomOverlayRef } from '../ga-metrics/custom-overlay-ref';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-date-range-selector',
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss'],
  providers: [provideGalaxyDateAdapter()],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DateRangeSelectorComponent implements OnInit {
  timeRangeOptions = AvailableDateRangeOptions;

  timeRangeSelected$: Observable<string>;
  selectedDateValue: string;

  datesHaveChanged = false;
  dateRangeSub: Subscription;
  dateRange: [Date, Date] = [null, null];
  maxDateRange: Date;

  constructor(
    private customOverlayRef: CustomOverlayRef,
    private dateRangeSelectorService: DateRangeSelectorService,
  ) {}

  ngOnInit(): void {
    this.maxDateRange = addDays(new Date(), 1);
    this.timeRangeSelected$ = this.dateRangeSelectorService.timeRange$;
    this.dateRangeSub = this.dateRangeSelectorService.dateRange$.pipe(take(1)).subscribe({
      next: (dateRange) => {
        this.dateRange = dateRange;
      },
    });
  }

  radioButtonChange(event: MatRadioChange): void {
    this.selectedDateValue = event.value;
  }

  setDateRange(): void {
    if (this.datesHaveChanged) {
      this.dateRangeSelectorService.setDateRange(this.dateRange);
    }
    if (this.selectedDateValue) {
      this.dateRangeSelectorService.setTimeRange(this.selectedDateValue);
    }
    this.customOverlayRef.close();
  }

  close(): void {
    this.customOverlayRef.close();
  }

  onStartChange(s: Date): void {
    if (!(s instanceof Date)) {
      s = (s as { toDate(): Date }).toDate();
    }
    this.dateRange[0] = s;
    this.datesHaveChanged = true;
  }

  onEndChange(e: Date): void {
    if (!(e instanceof Date)) {
      e = (e as { toDate(): Date }).toDate();
    }
    this.dateRange[1] = e;
    this.datesHaveChanged = true;
  }
}
